// extracted by mini-css-extract-plugin
export var bodySections = "_5x-8";
export var gray = "_5x-7";
export var green = "_5x-4";
export var iconContainer = "_5x-9";
export var iconWidgetContainer = "_5x-1";
export var phoneIcon = "_5x-2";
export var red = "_5x-5";
export var statusDot = "_5x-3";
export var widgetContainer = "_5x-0";
export var yellow = "_5x-6";